{
  "$id": "wealthlane://forms/vesting-template/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "id": "syncVestingTypeLabel",
      "watch": "vestingTypeId",
      "set": {
        "vestingTypeLabel": {
          "operator": "optionProp",
          "field": "vestingTypeId",
          "prop": "label"
        },
        "vestingType": {
          "operator": "optionProp",
          "field": "vestingTypeId",
          "prop": "label"
        },
        "isCliffVesting": {
          "operator": "optionProp",
          "field": "vestingTypeId",
          "prop": "isCliffVesting"
        },
        "isStepVesting": {
          "operator": "optionProp",
          "field": "vestingTypeId",
          "prop": "isStepVesting"
        },
        "isHybridVesting": {
          "operator": "optionProp",
          "field": "vestingTypeId",
          "prop": "isHybridVesting"
        }
      }
    },
    {
      "id": "resetFieldsOnVestingTypeChange",
      "watch": "vestingTypeId",
      "clear": [
        "periodStartDate",
        "vestsAfterInMonths",
        "amountOneInPercentage",
        "loadingTypeId",
        "specificVestingInstruction",
        "roundingTypeId"
      ]
    },
    {
      "id": "clearTermFieldsOnGenericVestingType",
      "watch": "vestingTypeId",
      "condition": {
        "allOf": [
          { "field": "vestingTypeLabel", "notEquals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "notEquals": "Custom Vesting Tranche" }
        ]
      },
      "clear": ["lengthInMonths", "intervalInMonths", "roundingTypeId"]
    },
    {
      "id": "seedSpecificVestingDefaults",
      "watch": "vestingTypeId",
      "condition": { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
      "set": {
        "lengthInMonths": { "operator": "literal", "value": 1 },
        "intervalInMonths": { "operator": "literal", "value": 1 }
      }
    },
    {
      "id": "seedTrancheDefaults",
      "watch": "vestingTypeId",
      "condition": { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" },
      "set": {
        "lengthInMonths": { "operator": "literal", "value": 1 },
        "intervalInMonths": { "operator": "literal", "value": 1 },
        "roundingTypeId": { "operator": "literal", "value": 1 }
      }
    },
    {
      "id": "cliffAutoFillOnTermPeriod",
      "watch": "lengthInMonths",
      "condition": { "field": "isCliffVesting", "equals": true },
      "set": {
        "vestsAfterInMonths": { "operator": "field", "name": "lengthInMonths" },
        "amountOneInPercentage": { "operator": "literal", "value": 100 },
        "intervalInMonths": { "operator": "literal", "value": 1 }
      }
    },
    {
      "id": "clearDependentsOnTermPeriodChange",
      "watch": "lengthInMonths",
      "condition": { "field": "isCliffVesting", "notEquals": true },
      "clear": ["intervalInMonths", "vestsAfterInMonths", "amountOneInPercentage"]
    },
    {
      "id": "clearIntervalOnHybridCliffsChange",
      "watch": "vestsAfterInMonths",
      "condition": { "field": "isHybridVesting", "equals": true },
      "clear": ["intervalInMonths"]
    },
    {
      "id": "mirrorStepIntervalToVestsAfter",
      "watch": "intervalInMonths",
      "condition": { "field": "isStepVesting", "equals": true },
      "set": {
        "vestsAfterInMonths": { "operator": "field", "name": "intervalInMonths" }
      }
    }
  ],
  "rules": [
    {
      "id": "rounding-type-required",
      "target": "roundingTypeId",
      "rule": "required",
      "message": "Required field",
      "condition": {
        "allOf": [
          { "field": "isCliffVesting", "notEquals": true },
          { "field": "vestingTypeLabel", "notEquals": "Custom Vesting Tranche" }
        ]
      }
    },
    {
      "id": "specific-vesting-json",
      "target": "specificVestingInstruction",
      "rule": "required",
      "message": "Required field",
      "condition": { "field": "vestingTypeLabel", "equals": "Specific Vesting" }
    },
    {
      "id": "specific-vesting-json-format",
      "target": "specificVestingInstruction",
      "rule": "custom",
      "customId": "vestingTemplateSpecificVestingJson",
      "message": "Invalid JSON format",
      "condition": { "field": "vestingTypeLabel", "equals": "Specific Vesting" }
    },
    {
      "id": "step-interval-divisible",
      "target": "intervalInMonths",
      "rule": "custom",
      "customId": "vestingTemplateStepIntervalDivisible",
      "message": "Vesting Frequency is invalid, enter a number that is divisible to Term Period",
      "condition": { "field": "isStepVesting", "equals": true }
    },
    {
      "id": "step-interval-max",
      "target": "intervalInMonths",
      "rule": "custom",
      "customId": "vestingTemplateIntervalMaxLessThanTerm",
      "message": "Please enter a valid Vesting Frequency less than the Term Period",
      "condition": { "field": "isStepVesting", "equals": true }
    },
    {
      "id": "hybrid-cliffs-max",
      "target": "vestsAfterInMonths",
      "rule": "custom",
      "customId": "vestingTemplateHybridCliffsMax",
      "message": "Please enter a valid Cliffs less than the Term Period",
      "condition": { "field": "isHybridVesting", "equals": true }
    }
  ],
  "observers": []
}
